import React, { useState } from "react";
import "./Abudhabi.css";
const img3 = require("../../../../assets/jsk/jsk1.jpg");

export const AbudhabiT = () => {
  const [sportsTab, setSportsTab] = useState("Fancy Bet");
  const [marketTab, setMarketTab] = useState("ALL");

  const marketTabs = [
    "ALL",
    "Fancy",
    "Line Markets",
    "Ball by Ball",
    "Meter Markets",
    "Khado Markets",
  ];

  const fancyMarkets = [
    { name: "DG 8.2 Ball Runs", no: 97, yes: 97, minmax: "100 - 25000" },
    { name: "DG Only 10th Over Runs", no: 13, yes: 13, minmax: "100 - 25000" },
    { name: "DG 9 Over Runs", no: 106, yes: 107, minmax: "100 - 50000" },
    { name: "DG 10 Over Runs", no: 117, yes: 119, minmax: "100 - 200000" },
    {
      name: "1st Innings 10 Over Line",
      no: 116,
      yes: 117,
      minmax: "100 - 25000",
    },
  ];

  return (
    <div className="abudhabi-page-wrapper container-fluid px-0">
      {/* Banner Section */}
      <div className="">
        <div className="w-full overflow-hidden">
          <img
            src={img3}
            alt="Abu Dhabi T10 Banner"
            className=""
            style={{ height: "200px", width: "100%" }}
          />
        </div>
      </div>

      {/* Title Bar */}
      <div
        className="text-white font-semibold p-2 text-lg shadow-md"
        style={{
          background:
            "linear-gradient(to bottom, rgb(206 48 48), rgb(56 4 4))",
        }}
      >
        Abu Dhabi T10 League
      </div>

      <div className="page-wrapper">
      {/* Match Odds */}
      <SectionHeader title="Match Odds" amount="€ 13.7M" />
      <OddsTable />

      {/* Bookmakers */}
      <SectionHeader title="Bookmakers" amount="€ 151.4M" />
      <BookmakerTable />

      {/* To Win The Match */}
      <SectionHeader title="To Win The Match" amount="€ 93.3K" />
      <WinMatch />

      {/* Fancy Bet / Sportsbook Toggle */}
      <div className="toggle-menu d-flex align-items-center px-2">
        {["Fancy Bet", "Sportsbook"].map((tab) => (
          <button
            key={tab}
            className={`toggle-btn ${sportsTab === tab ? "active" : ""}`}
            onClick={() => setSportsTab(tab)}
          >
            {tab}
          </button>
        ))}
        <div className="info-icon">ℹ️</div>
      </div>

      {/* Tabs Navigation */}
      <div className="tab-scroll d-flex overflow-auto px-2">
        {marketTabs.map((tab) => (
          <button
            key={tab}
            className={`tab-item ${marketTab === tab ? "active" : ""}`}
            onClick={() => setMarketTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Fancy Market Table */}
      <div className="table-responsive">
        <table className="table custom-table table-bordered">
          <thead>
            <tr>
              <th>Market</th>
              <th></th>
              <th className="no-bg text-center">No</th>
              <th className="yes-bg text-center">Yes</th>
              <th className="text-center">Min/Max</th>
            </tr>
          </thead>
          <tbody>
            {fancyMarkets.map((row, idx) => (
              <tr key={idx}>
                <td className="fw-bold">{row.name}</td>
                <td>
                  <button className="book-btn">Book</button>
                </td>
                <td className="no-bg odds text-center">
                  <strong>{row.no}</strong>
                  <div className="sub-value">100</div>
                </td>
                <td className="yes-bg odds text-center">
                  <strong>{row.yes}</strong>
                  <div className="sub-value">100</div>
                </td>
                <td className="text-center">{row.minmax}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
};

// ----- SUB COMPONENTS -----

const SectionHeader = ({ title, amount }) => (
  <div className="section-header px-2 py-1 d-flex justify-content-between align-items-center">
    <div className="d-flex align-items-center gap-2">
      <strong>{title}</strong>
      <span className="cashout-icon">🟡 Cash Out</span>
    </div>
    <span className="text-white fw-bold">Matched {amount}</span>
  </div>
);

const OddsTable = () => (
  <div className="odds-block">
    <div className="row g-0">
      <div className="col-6 d-flex align-items-center ps-2">Vista Riders</div>
      <OddsRow back="2.68" lay="2.78" volBack="3.7K" volLay="14.1K" />
    </div>
    <div className="row g-0">
      <div className="col-6 d-flex align-items-center ps-2">
        Deccan Gladiators
      </div>
      <OddsRow back="1.56" lay="1.58" volBack="7.1K" volLay="24.2K" />
    </div>
  </div>
);

const BookmakerTable = () => (
  <div className="odds-block">
    <MarketLine team="Vista Riders" back="167" lay="179" />
    <MarketLine team="Deccan Gladiators" back="56" lay="60" />
  </div>
);

const WinMatch = () => (
  <div className="odds-block">
    <div className="row g-0">
      <div className="col-6 d-flex align-items-center ps-2">Vista Riders</div>
      <OddsRow back="2.68" lay="2.78" volBack="3.7K" volLay="14.1K" />
    </div>
    <div className="row g-0">
      <div className="col-6 d-flex align-items-center ps-2">
        Deccan Gladiators
      </div>
      <OddsRow back="1.56" lay="1.58" volBack="7.1K" volLay="24.2K" />
    </div>
  </div>
);

const OddsRow = ({ back, lay, volBack, volLay }) => (
  <div className="col-6 d-flex">
    <div className="odds-box back">
      {back}
      <div>{volBack}</div>
    </div>
    <div className="odds-box lay">
      {lay}
      <div>{volLay}</div>
    </div>
  </div>
);

const MarketLine = ({ team, back, lay }) => (
  <div className="row g-0 bookmaker-line">
    <div className="col-6 ps-2">{team}</div>
    <div className="col d-flex justify-content-center back-box">{back}</div>
    <div className="col d-flex justify-content-center lay-box">{lay}</div>
  </div>
);
